import type { KudoContentObjectList } from 'models';
import { Modal, message } from 'ui';
import { KudoForm, type KudoFormValues } from '../kudo-form';
import { useUpdateKudoMutation } from '../queries';

type P = {
  isOpened: boolean;
  kudoContentObject: KudoContentObjectList;
  onCancel: () => void;
};

const EditKudoModal = ({ isOpened, kudoContentObject, onCancel }: P) => {
  const { isPending: isLoading, mutate: updateKudo } = useUpdateKudoMutation();

  const onSubmit = (values: KudoFormValues) => {
    updateKudo(
      {
        attachments: values.attachments.files,
        communityId: values.community?.value,
        htmlContent: values.htmlContent,
        id: kudoContentObject.kudo.id,
        pinned: values.pinned,
        textContent: values.textContent,
      },
      {
        onError() {
          message.error('Something went wrong, kudo cannot be edited.');
        },
        onSuccess() {
          message.success('Successfully updated');
          onCancel();
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Edit kudos" width="medium">
      <Modal.HugContent>
        <KudoForm isLoading={isLoading} kudoContentObject={kudoContentObject} mode="edit" onSubmit={onSubmit} />
      </Modal.HugContent>
    </Modal>
  );
};

export default EditKudoModal;
